module.exports = __webpack_public_path__ + "img/gcash.899b8154.png";